// Số điện thoại Việt Nam: chuyển đầu số 11 số cũ (trước 2018) sang 10 số và chuẩn hoá +84 / 84 về 0.
const OLD_PREFIX: Record<string, string> = {
  '0162': '032', '0163': '033', '0164': '034', '0165': '035', '0166': '036', '0167': '037', '0168': '038', '0169': '039',
  '0120': '070', '0121': '079', '0122': '077', '0126': '076', '0128': '078',
  '0123': '083', '0124': '084', '0125': '085', '0127': '081', '0129': '082',
  '0186': '056', '0188': '058', '0199': '059',
};
export function normPhone(raw: unknown): string {
  let d = String(raw ?? '').replace(/\D/g, '');
  if (d.startsWith('84') && (d.length === 11 || d.length === 12)) d = '0' + d.slice(2);
  if (d.length === 9 && /^[35789]/.test(d)) d = '0' + d;
  if (d.length === 11 && OLD_PREFIX[d.slice(0, 4)]) d = OLD_PREFIX[d.slice(0, 4)] + d.slice(4);
  return d;
}
export const validPhone = (p: string) => /^0[35789]\d{8}$/.test(p) || /^02\d{9}$/.test(p);
export const maskPhone = (p: string | null | undefined) => (p && p.length >= 7 ? `${p.slice(0, 3)}****${p.slice(-3)}` : p || '');
export const fmtPhone = (p: string | null | undefined) => (p && p.length === 10 ? `${p.slice(0, 4)} ${p.slice(4, 7)} ${p.slice(7)}` : p || '');
